import { render } from "./DocumentosComponent.vue?vue&type=template&id=5997cd7a"
import script from "./DocumentosComponent.vue?vue&type=script&lang=js"
export * from "./DocumentosComponent.vue?vue&type=script&lang=js"

import "./DocumentosComponent.vue?vue&type=style&index=0&id=5997cd7a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__